import { render, staticRenderFns } from "./SensorEditDialog.vue?vue&type=template&id=2d879e2a&scoped=true&"
import script from "./SensorEditDialog.vue?vue&type=script&lang=js&"
export * from "./SensorEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./SensorEditDialog.vue?vue&type=style&index=0&id=2d879e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d879e2a",
  null
  
)

export default component.exports